var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 30C21.732 30 28 23.2843 28 15C28 6.71573 21.732 0 14 0C6.26801 0 0 6.71573 0 15C0 23.2843 6.26801 30 14 30Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8258 25.6835C21.1838 28.4737 17.616 30.0261 13.9063 29.9996C10.1967 29.9731 6.6485 28.3699 4.04138 25.5423C4.3748 24.5543 5.02239 23.7239 5.87045 23.1966C6.44202 22.7438 7.0618 22.3655 7.71673 22.0694C6.72087 18.4029 9.428 16.6005 10.4637 16.0815C10.4637 17.7743 11.943 16.651 13.7789 16.6723C15.2903 16.6903 18.2793 18.3204 18.2793 16.1699C19.9421 16.6971 21.7544 20.0922 20.5071 22.1782C21.0185 22.4461 21.5016 22.7719 21.9483 23.15C22.8215 23.7454 23.4827 24.6378 23.8258 25.684V25.6835Z",
    fill: "#677079"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8883 18.7769L17.6482 18.8205V20.489L17.645 20.5147C17.6403 20.5903 17.6297 20.6653 17.6133 20.739L17.5906 20.9045L17.577 20.939C17.1394 23.4021 15.2242 24.3541 14.0417 25.0172C12.7957 24.29 11.0342 22.9798 10.8942 20.6618L10.8883 20.6332V20.5361C10.8873 20.5026 10.8867 20.4691 10.8865 20.4356C10.8865 20.4531 10.8878 20.4696 10.8883 20.4871V18.7769Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6487 18.7461V20.6903C17.6474 20.8705 17.633 21.0503 17.6057 21.2281C17.5714 21.4482 17.5136 21.6634 17.4335 21.8694C15.0848 23.7699 11.3424 22.2112 10.7448 18.965L17.6487 18.7461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20253 12.25C5.96433 12.8665 7.86725 15.7888 9.27496 15.7762C8.70727 14.6865 8.34302 13.4888 8.20253 12.25Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8615 12.25C22.0997 12.8665 20.1967 15.7888 18.7886 15.7757C19.3564 14.6863 19.7208 13.4887 19.8615 12.25Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9243 5.51514C23.2228 5.51514 19.5991 21.2657 13.9243 21.2657C8.56444 21.2657 4.62585 5.51514 13.9243 5.51514Z",
    fill: "#FFE8BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53595 10.7306C9.61527 10.8238 9.6741 10.9348 9.7081 11.0556C9.7421 11.1763 9.75041 11.3036 9.73241 11.4283C9.71442 11.5529 9.67058 11.6716 9.60412 11.7757C9.53766 11.8798 9.45027 11.9666 9.34837 12.0297C8.69141 12.6088 8.6674 14.6282 8.6674 14.6282C8.41368 14.3583 8.41957 12.9127 7.86953 12.0773C7.3195 11.2418 6.94888 5.39616 10.0248 3.27043C9.8358 3.50863 9.69957 3.7896 9.62636 4.09226C9.55315 4.39492 9.54486 4.71142 9.6021 5.018C9.6021 5.018 11.7388 1.73498 15.2837 1.82965C15.0026 1.99383 14.757 2.21961 14.5629 2.49228C14.3687 2.76495 14.2304 3.07839 14.1569 3.41217C14.1569 3.41217 17.2559 2.04227 19.8384 3.67188C19.167 3.87072 18.532 4.19032 17.9604 4.61703C19.2146 4.65393 20.4265 4.90344 21.3404 5.77432C21.1437 5.84197 20.9617 5.95117 20.8051 6.09546C20.6484 6.23975 20.5204 6.41622 20.4285 6.61442C20.3366 6.81263 20.2827 7.02856 20.27 7.24945C20.2573 7.47035 20.286 7.69174 20.3545 7.90054C20.7423 9.60103 20.7786 11.1831 20.403 12.0336C20.0274 12.884 19.8502 12.335 19.6151 14.1185C19.6035 14.239 19.566 14.355 19.5055 14.4572C19.4449 14.5595 19.363 14.6453 19.2662 14.7078C19.2571 14.837 19.4393 12.8845 18.9694 12.3646C18.5001 11.8452 18.795 11.2069 18.9826 10.8292C20.292 8.19471 16.3706 7.00102 14.2271 7.00393C12.3681 7.00636 7.88403 7.9117 9.53595 10.7306Z",
    fill: "#8A5C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96643 23.8652C8.98002 23.8836 13.6866 30.4103 19.2195 23.7681C18.5512 25.7351 15.6688 27.2972 14.02 27.2923C10.8712 27.2826 9.12863 24.5739 8.96643 23.8652Z",
    fill: "#434955"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4629 29.7685C16.2771 29.8035 16.0905 29.8341 15.9025 29.8618V25.5234C15.9093 25.4507 15.9425 25.3838 15.9948 25.337C16.0472 25.2902 16.1145 25.2672 16.1825 25.2729C16.2505 25.2671 16.3179 25.29 16.3704 25.3368C16.4228 25.3837 16.456 25.4506 16.4629 25.5234V29.7685ZM12.0137 29.8491C11.8258 29.8203 11.639 29.788 11.4532 29.752V25.5234C11.4601 25.4507 11.4933 25.3838 11.5456 25.337C11.5979 25.2902 11.6653 25.2672 11.7332 25.2729C11.8014 25.2669 11.8689 25.2898 11.9215 25.3367C11.974 25.3835 12.0073 25.4505 12.0142 25.5234L12.0137 29.8491Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ef8209d2ac90f87f9cd6f4128ff886a6.svg";
export { ForwardRef as ReactComponent };